import { FC, memo, useRef } from "react"

import { useDrawingManagerEvents, useOverlaySnapshots } from "../functions"

interface Props {
  drawingManager: google.maps.drawing.DrawingManager | null
}

export const UndoRedoControl: FC<Props> = memo(({ drawingManager }: Props) => {
  const overlaysShouldUpdateRef = useRef<boolean>(false)

  useDrawingManagerEvents(drawingManager, overlaysShouldUpdateRef)
  useOverlaySnapshots(overlaysShouldUpdateRef)

  /* TODO: add actions undo & redo */
  return null
})
